import { MenuItem } from "./menu.types";

export const menuItems4: MenuItem[] = [
  
  { id: 7, label: "Chats", icon: "lab la-rocketchat", to: "/chats", permissionId: 7 },
];
